var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReleaseNotes"},[_c('PlainNavBar'),(_vm.menu.length)?_c('ParentPage',{staticClass:"ReleaseNotes",attrs:{"menu":_vm.menu,"root-route-name":_vm.rootRouteName}}):_vm._e(),_c('Overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }